export const firebaseConfig = {
    apiKey: "AIzaSyCzcMuqS56e4HT3CM7guvPIqrbzf_EDULM",
    authDomain: "wix-customer-feedback.firebaseapp.com",
    projectId: "wix-customer-feedback",
    storageBucket: "wix-customer-feedback.appspot.com",
    messagingSenderId: "186779038351",
    appId: "1:186779038351:web:ac42e4f120bae47b0336fa"
};
